define([
	"dojo/_base/declare",
	"csi/heading/SelectController",
	"csi/locale",
	"csi/state/rootStore"
], function(declare,SelectController,locale,{ sessionStore }) {

	return declare(SelectController, {
		postProcessSuccess: function() {
			// summary: set the storage to the new Locale value for Dojo to pick up upon reloading of the page for the current user
			this.inherited(arguments);

			if ((this.newValue != this.oldValue) && (this.m_urlNode == sessionStore.userDetailsUrl)) {
				locale.storeLocale(this.newValue);
			}
		}
	});
});